import Vue from "vue";

Vue.component('remote-script', {
  render: function (createElement) {
    var self = this;
    return createElement('script', {
      attrs: {
        type: 'text/javascript',
        src: this.src
      },
      on: {
        load: function (event) {
          self.$emit('load', event);
        },
        error: function (event) {
          self.$emit('error', event);
        },
        readystatechange: function (event) {
          if (this.readyState == 'complete') {
            self.$emit('load', event);
          }
        }
      }
    });
  },

  props: {
    src: {
      type: String,
      required: true
    }
  }
});

import config from '../assets/config.json'
import web_conf from '../assets/web.json'
import manhua_conf from '../assets/manhua.json'
import image_hosts_conf from '../assets/configs/web/image.hosts.json'
import buy_gold_conf from '../assets/configs/vip/buy.gold.json'
import vip_degree_conf from '../assets/configs/vip/vip_degree.json'



Vue.prototype.$config = config
Vue.prototype.$web_conf = web_conf
Vue.prototype.image_hosts_conf = image_hosts_conf
Vue.prototype.$buy_gold_conf = buy_gold_conf
Vue.prototype.$vip_degree_conf = vip_degree_conf
Vue.prototype.$manhua_conf = manhua_conf


window.xx = Vue.prototype;